import { Controller } from "@hotwired/stimulus"

// Live availability check for the workspace slug field in onboarding.
// Debounced so we don't hammer the endpoint on every keystroke.
export default class extends Controller {
  static targets = ["input", "status"]
  static values  = { endpoint: String }

  connect() {
    this.check()
  }

  check() {
    clearTimeout(this._t)
    this._t = setTimeout(() => this._fetch(), 280)
  }

  async _fetch() {
    const v = this.inputTarget.value.trim().toLowerCase()
    if (!v) return

    try {
      const res  = await fetch(`${this.endpointValue}?slug=${encodeURIComponent(v)}`,
                               { headers: { Accept: "application/json" } })
      const data = await res.json()
      this.statusTarget.classList.remove("is-available", "is-unavailable")
      if (data.available) {
        this.statusTarget.classList.add("is-available")
        this.statusTarget.textContent = "● DISPONIBLE"
      } else {
        this.statusTarget.classList.add("is-unavailable")
        this.statusTarget.textContent = `● ${data.reason}`
      }
    } catch (_e) {
      this.statusTarget.textContent = "● vérification…"
    }
  }

  fill(event) {
    this.inputTarget.value = event.params.slug
    this.check()
  }
}
